import redirector from "./redirector.component";
import redirectorUrls from "./redirector.urls";
import RedirectorTransforms from "./redirector.transforms";

const redirectorModule = angular
  .module("app.components.redirector", [])
  .component("redirectorPage", redirector)
  .service("RedirectorTransforms", RedirectorTransforms)
  .config(redirectorUrls);

export default redirectorModule;



// WEBPACK FOOTER //
// ./src/pages/redirector/redirector.module.js